
export const archiveOptions = [
  { label: "All", value: "all" },
  { label: "Yes", value: "yes"},
  { label: "No", value: "no" },
];